// db.ts
import Dexie, { Table } from 'dexie';
import { Timestamp } from 'rxjs-compat';
import { timestamp } from 'rxjs-compat/operator/timestamp';

export interface Tabla {
    id: string;
    prefijo: string;
    empresa: string;
    fecha_hora: Date;
    tabla: string;
    registros: Array<any>;
}
export interface Ctr_cache {
    id: string;
    fecha_hora: Date;
    empresa: string;
    prefijo: string;
    tablaId: string;
}

export class AppDB extends Dexie {
    Tablas!: Table<Tabla, number>;
    Ctr_caches!: Table<Ctr_cache, number>;

    constructor() {
        super('NETSOLIN');
        this.version(3).stores({
            Tablas: '++id',
            Ctr_caches: '++id, tablaId',
        });
        this.on('populate', () => this.populate());
    }

    async populate() {
        const tablasId = await db.Tablas.add({
            id: 'TERCEROS_BOCCHERINI',
            prefijo: 'BOCCHE',
            empresa: 'BOCCHERINI',
            tabla: 'TERCEROS',
            fecha_hora: new Date(),
            registros: [{
                tablaId: 'TABLA1',
                id: '1',
                fecha_hora: new Date(),
                empresa: 'BOCCHERINI',
                prefijo: 'BOCCHE',
            },
            {
                tablaId: 'TABLA2',
                id: '2',
                fecha_hora: new Date(),
                empresa: 'BOCCHERINI',
                prefijo: 'BOCCHE',
            },
            {
                tablaId: 'TABLA3',
                id: '3',
                fecha_hora: new Date(),
                empresa: 'BOCCHERINI',
                prefijo: 'BOCCHE',
            },
            {
                tablaId: 'TABLA4',
                id: '4',
                fecha_hora: new Date(),
                empresa: 'BOCCHERINI',
                prefijo: 'BOCCHE',
            }]
        });
        await db.Ctr_caches.bulkAdd([
            {
                tablaId: tablasId.toString(),
                id: '1',
                fecha_hora: new Date(),
                empresa: 'BOCCHERINI',
                prefijo: 'BOCCHE',
            },
            {
                tablaId: tablasId.toString(),
                id: '2',
                fecha_hora: new Date(),
                empresa: 'BOCCHERINI',
                prefijo: 'BOCCHE',
            },
            {
                tablaId: tablasId.toString(),
                id: '3',
                fecha_hora: new Date(),
                empresa: 'BOCCHERINI',
                prefijo: 'BOCCHE',
            },
            {
                tablaId: tablasId.toString(),
                id: '4',
                fecha_hora: new Date(),
                empresa: 'BOCCHERINI',
                prefijo: 'BOCCHE',
            },
        ]);
    }
}

export const db = new AppDB();